import {LiveChecksStatusBadge} from '@github-ui/commit-checks-status/LiveChecksStatusBadge'
import {type ComponentProps, useMemo} from 'react'
import {StatusCheckState, type StatusCheckRollup} from './types/list-types'

interface PullsChecksStatusBadgeProps {
  headSha: string
  repositoryNwo: string
  statusCheckRollup: StatusCheckRollup
  aliveChannel?: string | null
  buttonClassName?: ComponentProps<typeof LiveChecksStatusBadge>['buttonClassName']
  buttonVariant?: ComponentProps<typeof LiveChecksStatusBadge>['buttonVariant']
  iconOnly?: ComponentProps<typeof LiveChecksStatusBadge>['iconOnly']
}

function mapStatusStateToRollup(state: StatusCheckState): 'success' | 'failure' | 'pending' {
  switch (state) {
    case StatusCheckState.Success:
      return 'success'
    case StatusCheckState.Failure:
      return 'failure'
    case StatusCheckState.Pending:
      return 'pending'
    default:
      return 'pending'
  }
}

export function PullsChecksStatusBadge({
  headSha,
  repositoryNwo,
  statusCheckRollup,
  aliveChannel,
  buttonClassName,
  buttonVariant,
  iconOnly,
}: PullsChecksStatusBadgeProps) {
  const [ownerLogin = '', name = ''] = repositoryNwo.split('/')
  const repo = useMemo(() => ({ownerLogin, name}), [ownerLogin, name])

  const descriptionText = `${statusCheckRollup.successCount}/${statusCheckRollup.totalCount}`
  const ariaLabel = `${descriptionText} checks passing`

  return (
    <LiveChecksStatusBadge
      oid={headSha}
      statusRollup={mapStatusStateToRollup(statusCheckRollup.state)}
      repo={repo}
      aliveChannel={aliveChannel}
      size="small"
      variant="default"
      descriptionText={descriptionText}
      ariaLabel={ariaLabel}
      buttonClassName={buttonClassName}
      buttonVariant={buttonVariant}
      iconOnly={iconOnly}
    />
  )
}
